export default __webpack_public_path__ + "static/media/background-experimental.d917f8f4.jpg";